import React from 'react';
import Asset from '../../requests/apa/Asset';
import Utils from "../../utils/Utils";

function focusHandler(focusHandlerCallBack, data) {
  if (window.setResumeData) window.setResumeData(data);
  return typeof focusHandlerCallBack === 'function' ? focusHandlerCallBack(data) : null;
}

function keyUpHandler(keyUpHandlerCallBack, props) {
  return typeof keyUpHandlerCallBack === 'function' ? keyUpHandlerCallBack(props) : null;
}

function keyDownHandler(e, keyDownHandlerCallBack, params) {
  return typeof keyDownHandlerCallBack === 'function' ? keyDownHandlerCallBack(e, params) : null;
}

function createBadge(badge, extraSpace = false) {
  return badge !== '' ? (
    <div className={`box-badge-styles ${extraSpace ? 'extra-space' : ''}`} dangerouslySetInnerHTML={{ __html: badge }}></div>
  ) : '';
}

function getPlaceholder(type) {
  let placeholder = null;

  switch (type) {
    case 'highlight':
      placeholder = Asset.get(
        'asset_placeholder_highlight',
        '/images/placeholder_highlight.png'
      );
      break;
    case 'landscape':
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
      break;
    case 'portrait':
      placeholder = Asset.get(
        'asset_placeholder_portrait',
        '/images/placeholder_portrait.png'
      );
      break;
    case 'user-profile':
    case 'user-info':
      placeholder = Asset.get(
        'placeholder_talent_movie',
        '/images/placeholder_talent_movie.png'
      );
      break;
    case 'cd':
    case 'square':
    case 'circle':
      placeholder = Asset.get('asset_placeholder_square', '/images/placeholder_square.png');
      break;
    case 'actor':
    case 'casting':
    case 'costume designer':
    case 'original music':
    case 'production design':
    case 'screenwriter':
    case 'set decoration':
    case 'art director':
    case 'supervising art direction':
    case 'executive producer':
    case 'film editor':
    case 'cinematographer':
    case 'producer':
    case 'talent':
    case 'narrator':
    case 'voice':
    case 'director':
    case 'writer':
    case 'conductor':
      placeholder = Asset.get(
        'content_data_talent_placeholder',
        '/images/content_data_talent_placeholder.png'
      );
      break;
    default:
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
  }

  return placeholder;
}

function getUri(href, group_id, data, ignoreSeenLast) {
  href = data.href || data.src || `/vcard/${group_id || ''}`;
  if (data.live_enabled == '1') href = `/player/${group_id}`;
  if (href.indexOf('/vcard/') !== -1) href = `${href}${ignoreSeenLast ? '/1' : ''}`;
  return href;
}

function createSibling(sibling) {
  const siblingComponent = (
    <div className="placeholder-container">
      <div className="sibling-wrapper">
        <div
          className="card-placeholder"
          style={{ backgroundImage: `url(${this.getPlaceholder('portrait')})` }}
          alt="placeholder"
        />
        <img className="card-cover" src={sibling} />
      </div>
      <div className="arrow-right" />
    </div>
  );

  return sibling ? siblingComponent : null;
}

function createTitle(title, showTitle, isChannel = false) {
  const titleComponent = <div className="card-title">
    <span className="title-bottom">{title}</span>
  </div>;

  return isChannel ? titleComponent : title && title.length && showTitle ? titleComponent : null;
}

function createSubTitle(subTitle) {
  const titleComponent = <div className="card-subtitle">
    <span className="subtitle-bottom">{subTitle}</span>
  </div>;

  return subTitle.length ? titleComponent : null;
}

function createLabel(label) {
  const span = <div className="card-label"
    dangerouslySetInnerHTML={{ __html: label }} />;

  return label.length ? span : null;
}

function posterTitleIsEnabled(provider = 'default', display = 'landscape') {

  if(typeof provider !== 'string') return false;

  provider = provider.toLowerCase().split(' ').join('');
  let poster_title_configuration = Utils.getAPARegionalized('poster_title_configuration', provider, {
    "default": { "portrait": true, "landscape": true },
    "amco": { "portrait": false, "landscape": false },
    "fox": { "portrait": true, "landscape": true },
    "hbo": { "portrait": true, "landscape": true },
    "noggin": { "portrait": true, "landscape": true },
    "picardia": { "portrait": true, "landscape": true },
    "edye": { "portrait": true, "landscape": true },
    "paramount": { "portrait": true, "landscape": true },
    "stingrayqello": { "portrait": true, "landscape": true },
    "stingraykaraoke": { "portrait": true, "landscape": true },
    "atresplayer": { "portrait": true, "landscape": true }
  });
  if (poster_title_configuration[display]) {
    return poster_title_configuration[display];
  }
  poster_title_configuration = poster_title_configuration[provider] ? poster_title_configuration[provider] : poster_title_configuration['default'];
  return poster_title_configuration && poster_title_configuration[display] ? poster_title_configuration[display] : false;
}

function createPlayerIcon() {
  return (
    <div className={'player-icon'}>
      <img src={Asset.get('content_playing_option_button_play', '')} alt="player icon" />
    </div>
  );
}

function createProgressBar(bookmark, hasPlayerIcon) {
  if (bookmark && bookmark !== '0') {
    return (
      <div>
        {bookmark && bookmark !== '0' && (
          <div className={`progress-bar-container-card ${hasPlayerIcon ? 'reduce-bar' : ''}`}>
            <div className="progress-bar" style={bookmark && Number(bookmark) >= 0 && Number(bookmark) <= 100 ? { width: bookmark + '%' } : {}}></div>
          </div>
        )}
        {hasPlayerIcon && (createPlayerIcon())}
      </div>
    );
  }
}

function createDeleteIcon() {
  return (
    <span className={'delete-action-icon'}>
        <span className="color-ball red" />
        <i className="fa fa-trash-o" />
      </span>
  );
}

function createFooter(showTrashButton, showActions, isTitleEnable = false) {
  if (showTrashButton && showActions) {
    return (
      <div className="card-title">
        <span className={`footer-actions ${isTitleEnable ? 'fix-top-icon' : ''}`}>
        {createDeleteIcon()}
      </span>
      </div>
    );
  }
}

function fillZeroLeft(num, size) {
  if (!num) return '';
  num = num.toString();
  while (num.length < size) num = "0" + num;

  return num;
}

function getTimeProgress(startUnixtime, endUnixtime) {
  let justNow = Utils.nowAsTimestampSeconds();
  let progress = 0;
  // console.log('PGRESS ', justNow, startUnixtime, endUnixtime);
  if (startUnixtime <= justNow && endUnixtime > justNow) {
    const duration = endUnixtime - startUnixtime;
    let limit_forward = endUnixtime - justNow;
    let dur_limit_forward = endUnixtime - startUnixtime - limit_forward;
    const percent = dur_limit_forward > 0 ? (dur_limit_forward * 100) / duration : 0;
    progress =  percent <= 100 ? percent : 100;
  }
  // console.log('PGRESS: ', progress, '%');

  return progress;
}

export default {
  getPlaceholder,
  getUri,

  createSibling,
  createTitle,
  createLabel,

  focusHandler,
  keyUpHandler,
  keyDownHandler,

  posterTitleIsEnabled,
  createBadge,
  createProgressBar,
  createFooter,
  createDeleteIcon,
  fillZeroLeft,
  getTimeProgress,
  createPlayerIcon,
  createSubTitle
};



// WEBPACK FOOTER //
// ./src/components/CardNew/helpers.js